import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import config from '../config'

Vue.use(Vuex)

export default new Vuex.Store({
  /* eslint-disable */
  state: {
    sending: false,
    notification: '',
    showNotification: false,
    uuid: null,
    email: null,
    pin: null,
    status: null,
    completed: false
  },
  
  mutations: {
    setSending: ({ sending }, val) => sending = val,
    setNotification: ({ notification }, val) => notification = val,
    setShowNotification: ({ showNotification }, val) => showNotification = val,
    setUuid: ({ uuid }, val) => uuid = val,
    setEmail: ({ email }, val) => email = val,
    setStatus: ({ status }, val) => status = val,
    setCompleted: ({ completed }, val) => completed = val,
    setPin: ({ pin }, val) => pin = val
  },
  
  actions: {
    async sendForgotPasswordRequest({ commit, state }, email) {
      var data = { email: email }
      console.log(data)
      // commit('setSending', true)
      state.sending = true
      var res
      try {
	res = await axios.post(
          config.apiUrl + '/v1/user/forgot-password',
          data,
          { headers: { 'Access-Control-Allow-Origin': '*' }},
	  
	)
      } catch( error ) {
	// We will ignore errors now on
	// state.status = 'error'
	state.status = 'ok'
	state.uuid = '12345'
	state.email = email
      }
      // commit('setSending', false)
      state.sending = false
      console.log(res)
      if (res && res.data.status == "ok") {
	// commit('setUuid', res.data.uuid)
	state.uuid = res.data.uuid
      } else {
	state.uuid = '12345'
      }
      state.status = 'ok'
      state.email = email
        
      var notification = res && res.data.status == "ok" ? "Email instructions sent." : "Problem with sending instructions, please contact support."

      // commit('setNotification', notification)
      //commit('setShowNotification', notification)
      //state.notification = notification
      state.notification = "Email instructions sent."
      state.showNotification = true

    },

    async checkPasswordPin({ commit, state }, pin) {
      //commit('setSending', true)

      state.sending = true
      
      var data = {
	uuid: state.uuid,
	pin: pin
      }

      var res = null
      try {
	res = await axios.post(
	  config.apiUrl + '/v1/user/validate-password-reset-pin',
	  data)
      } catch ( error ) {
	state.status = 'error'
      }

      state.sending = false
      console.log(res)

      if (res && res.data.status == "ok") {
	state.status = 'valid'
	state.pin = pin
	state.notification = "Pin validated."
      } else {
	state.status = 'error'
	state.notification = 'PIN validation failed.'
      }

      state.setShowNotification = true

    },
      
    
    async changePassword({ commit, state }, password) {

      state.sending = true

      var data = {
	uuid: state.uuid,
	pin: state.pin,
	password: password
      }
      
      var res = await axios.post(
        config.apiUrl + '/v1/user/change-password',
        data,
        { headers: { 'Access-Control-Allow-Origin': '*' }},
        
      )

      state.sending = false
      var notification

      console.log(res)
      switch(res.data.status) {
      case "ok":
        notification = "Password successfully changed."
	state.completed = true
	state.status = 'completed'
        break

      case "error":
        notification = res.data.message
	state.status = 'error'
        break
      default:
	state.status = 'error'
        notification = "Something went wrong. Contact support."
        break
      }
      state.notification = notification
      state.showNotification = true

    }
    
  },
  modules: {
  }
})
